export default "__VITE_ASSET__CUZtUmNg__"